import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BrightTypography: typeof Typography = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
}));

export const DarkTypography: typeof Typography = styled(BrightTypography)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
}));

export const BoldTypography: typeof Typography = styled(Typography)({
  fontWeight: 700,
  fontSize: 700,
});
